import { useState, useEffect } from "react";
import Step1Upload from "@/pages/smartfile/Step1Upload";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Sparkles } from "lucide-react";
import { isAIDisabled, setAIDisabled } from "@/lib/smartfile-ai-preference";

interface CompactSmartfileProps {
  description?: string;
  appHomeStyle?: boolean;
  basePath?: "/app" | "/paciente";
}

export function CompactSmartfile({
  description = "Insira os dados clínicos de qualquer paciente",
  appHomeStyle = false,
  basePath = "/app",
}: CompactSmartfileProps) {
  const navigate = useNavigate();
  const [disableAI, setDisableAI] = useState(() => isAIDisabled());
  const disableAiId = appHomeStyle ? "disable-ai-home-card" : "disable-ai-patient-card";

  // Salvar no localStorage sempre que mudar
  useEffect(() => {
    setAIDisabled(disableAI);
  }, [disableAI]);

  return (
    <Card className="h-full min-h-[280px] border border-border/50 rounded-lg bg-card/50 shadow-sm">
      <CardHeader className="pb-1">
        <div className="flex items-start gap-3 min-w-0">
          <Sparkles className="mt-1 h-4 w-4 text-primary shrink-0" />
          <div className="min-w-0">
            <CardTitle className={appHomeStyle ? "text-sm font-semibold text-primary" : "text-sm font-semibold"}>
              Dados de Saúde
            </CardTitle>
            <CardDescription className="mt-1 text-xs">{description}</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="flex-1 pt-1 pb-4 space-y-4">
        <Step1Upload
          patientId={null}
          onComplete={(sessionId) => {
            navigate(`${basePath}/smartfile?sessionId=${sessionId}`);
          }}
          compact={true}
          compactVariant={appHomeStyle ? "home" : "default"}
          disableAI={disableAI}
        />

        <div className="flex items-center gap-2 pt-1">
          <Checkbox
            id={disableAiId}
            checked={disableAI}
            onCheckedChange={(checked) => setDisableAI(checked === true)}
            className="rounded-full border-primary/50 data-[state=checked]:border-primary"
          />
          <Label
            htmlFor={disableAiId}
            className="cursor-pointer text-xs text-muted-foreground"
          >
            Desativar Resumo e Insights IA
          </Label>
        </div>
      </CardContent>
    </Card>
  );
}
